import { nextTick } from 'vue';
import { useLocalStorage } from '@vueuse/core';

export function useSearchHistory() {
	const historyStorage = useLocalStorage('search_history', '[]');
	const history = JSON.parse(historyStorage.value);

	async function updateSearchHistory(item) {
		const matchedIndex = history.findIndex(existing => existing.link === item.link);
		let newHistory = [...history];

		if (matchedIndex >= 0) {
			newHistory.splice(matchedIndex, 1);
		}
		newHistory.unshift(item);
		newHistory = newHistory.slice(0, 10);
		historyStorage.value = JSON.stringify(newHistory);

		// allow DOM update to complete
		await nextTick();

		return newHistory;
	}

	return {
		history,
		updateSearchHistory,
	};
}
